import { render } from "./LoadDataSources.vue?vue&type=template&id=a8c1afe0"
import script from "./LoadDataSources.vue?vue&type=script&lang=js"
export * from "./LoadDataSources.vue?vue&type=script&lang=js"

import exportComponent from "/builds/dock/research/autocbm/autocbm-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__